<template>
  <div
    class="h-fit min-w-60 rounded-3xl overflow-hidden flex flex-col border-2 border-white bg-white justify-between"
  >
    <RouterLink
      v-for="(item, idx) in menu"
      :key="idx"
      :to="item.route"
      class="group w-full"
    >
      <div
        class="px-5 py-2.5 flex gap-x-3 items-center hover:bg-gray-100 transition-300 w-full group"
        :class="isActive(item) ? 'bg-gray-100' : ''"
      >
        <div
          class="p-2 bg-gray-250 w-fit h-fit flex items-center rounded-2lg border border-gray-250"
          :class="isActive(item) ? 'bg-yellow-400 border-yellow-300' : ''"
        >
          <i
            :class="
              item.icon +
              ' text-gray-500 text-xl/5 transition-300 ' +
              (isActive(item) ? '!text-white' : '')
            "
          />
        </div>
        <p :key="locale" class="text-sm text-dark font-semibold">
          {{ item.label }}
        </p>
      </div>
    </RouterLink>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { ref, watch } from "vue";

const { t, locale } = useI18n();

const menu = ref([
  {
    label: t("notifications"),
    icon: "icon-bell",
    route: "/profile/notifications",
    children: [{ route: "/profile/notifications" }],
  },
  {
    label: t("personal_info"),
    icon: "icon-user",
    route: "/profile/personal-info",
    children: [{ route: "/profile/personal-info/edit" }],
  },
  {
    label: t("class_schedule"),
    icon: "icon-list",
    route: "/profile/class-schedule",
  },
  {
    label: t("payment_infos"),
    icon: "icon-clock",
    route: "/profile/payment-info",
  },
  {
    label: t("contracti"),
    icon: "icon-doc",
    route: "/profile/contracts",
  },
  {
    label: t("contact"),
    icon: "icon-ring-phone",
    route: "/profile/contacts",
  },
]);

const route = useRoute();

const isActive = (routeItem: object) => {
  if (route.path === routeItem.route) {
    return true;
  }
  if (routeItem.children) {
    return routeItem.children.some(
      (child: object) =>
        route.path === child.route || route.path.startsWith(routeItem.route),
    );
  }
  return false;
};

watch(locale, () => {
  // Обновляем меню при изменении локали
  menu.value = [
    {
      label: t("notifications"),
      icon: "icon-bell",
      route: "/profile/notifications",
      children: [{ route: "/profile/notifications" }],
    },
    {
      label: t("personal_info"),
      icon: "icon-user",
      route: "/profile/personal-info",
      children: [{ route: "/profile/personal-info/edit" }],
    },
    {
      label: t("contract"),
      icon: "icon-doc",
      route: "/profile/contracts",
    },
    {
      label: t("payment_infos"),
      icon: "icon-clock",
      route: "/profile/payment-info",
    },
    {
      label: t("contact"),
      icon: "icon-ring-phone",
      route: "/profile/contacts",
    },
  ];
});
</script>
